import { Component, inject, input, LOCALE_ID, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { UserInfoTab } from './user-info-tab/user-info-tab';
import { UserDetailsVTO } from '../../../../services/auth-service.model';
import { RoleVTO } from '../../../../services/role/role-service.model';


@Component({
  selector: 'app-user-details-component',
  imports: [CommonModule, DatePipe, UserInfoTab],
  templateUrl: './user-details-component.html',
  styleUrl: './user-details-component.scss',
})
export class UserDetailsComponent {
  private locale = inject(LOCALE_ID);

  data = input.required<UserDetailsVTO>();

  activeTab = signal<'info' | 'roles' | 'activity-logs'>('info');

  setActiveTab(tab: 'info' | 'roles' | 'activity-logs') {
    this.activeTab.set(tab);
  }

  get fullName(): string {
    return `${this.data().firstName} ${this.data().lastName}`.trim();
  }

  getRoleColors(index: number): string {
    const colors = [
      'bg-green-100 text-green-700',
      'bg-purple-100 text-purple-700',
      'bg-blue-100 text-blue-700',
      'bg-yellow-100 text-yellow-700',
      'bg-pink-100 text-pink-700',
    ];
    return colors[index % colors.length];
  }

  getRoleTitle(role: RoleVTO): string {
    return this.isArabic() ? role.titleAr : role.titleEn;
  }

  isArabic(): boolean {
    return this.locale.startsWith('ar');
  }
}